import { PluginFunction, PluginOptions } from './plugin';

const NormalizeRequestLogEntry: PluginFunction = ({ method: loglevelMethod, message }: PluginOptions) => {
  if (typeof message == 'object' && message.url) {
    const { status, method, ...meta } = message;

    if (status || method) {
      const resolvedMeta = {
        ...meta,
        status: status ? status : null,
        method: method && typeof method == 'string' ? method.toUpperCase() : null,
      };
      return loglevelMethod(resolvedMeta);
    }
  }

  return loglevelMethod(message);
};

export { NormalizeRequestLogEntry };
